export const isFuneralHome = firm => {
  if (!firm) return false

  return firm && firm.get('firm-type') === 'funeral_home'
}
